"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserPermitted = exports.resolveUserEntityRoles = void 0;
var resolveUserEntityRoleAssignments = function (user, roleAssignments) {
    return roleAssignments.filter(function (roleAssignment) {
        return (roleAssignment.type === 'user' && roleAssignment.user === user.id) ||
            (roleAssignment.type === 'department' && roleAssignment.department === user.departmentId) ||
            (roleAssignment.type === 'role' && user.roles.includes(roleAssignment.role));
    });
};
var resolveUserEntityRoles = function (user, roleAssignments) {
    var userEntityRoleAssignments = resolveUserEntityRoleAssignments(user, roleAssignments);
    return userEntityRoleAssignments.reduce(function (roles, roleAssignment) {
        if (!roleAssignment.entityRoles) {
            return roles;
        }
        var newRoles = __spreadArray([], roles, true);
        roleAssignment.entityRoles.forEach(function (role) {
            if (!newRoles.includes(role)) {
                newRoles.push(role);
            }
        });
        return newRoles;
    }, []);
};
exports.resolveUserEntityRoles = resolveUserEntityRoles;
function isUserPermitted(user, roleAssignments, permittedRoles) {
    if (permittedRoles) {
        var resolvedRoles = (0, exports.resolveUserEntityRoles)(user, roleAssignments);
        return Boolean(resolvedRoles.filter(function (resolvedRole) { return permittedRoles.includes(resolvedRole); }).length);
    }
    var userEntityRoleAssignments = resolveUserEntityRoleAssignments(user, roleAssignments);
    return userEntityRoleAssignments.length > 0;
}
exports.isUserPermitted = isUserPermitted;
